import CsvImport from "./CsvImport";

// export default function AdminDashboard() {
//   const storeId = "sarah"; // later: you can select from dropdown

//   return (
//     <div>
//       <h1>Wear & Wonder Admin</h1>
//       <CsvImport storeId={storeId} />
//     </div>
//   );
// }
import React, { useState } from "react";
import Papa from "papaparse";
import { custDb } from "../../firebaseCust"; 

import StoreBranding from "./admin/StoreBranding";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import OrderExport from "./admin/OrderExport";

export default function AdminDashboard() {
  const [products, setProducts] = useState([]);
  const [storeCode, setStoreCode] = useState("");

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (results) {
        setProducts(results.data);
      }
    });
  };

  const uploadToFirestore = async () => {
    if (!storeCode) {
      alert("Please enter Store Code");
      return;
    }

    for (let product of products) {
      await addDoc(collection(custDb, "customers", storeCode, "products"), {
        ...product,
        price: Number(product.price),
        createdAt: serverTimestamp()
      });
    }

    alert("Products uploaded successfully!");
    setProducts([]);
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Admin Dashboard</h1>

      <label>Store Code (ex: fashion123):</label>
      <input
        className="border p-2 block mb-4 w-full max-w-md"
        value={storeCode}
        onChange={(e) => setStoreCode(e.target.value)}
      />

      <input type="file" accept=".csv" onChange={handleFileUpload} />

      <button
        onClick={uploadToFirestore}
        className="block mt-4 bg-black text-white px-6 py-2 rounded"
      >
        Upload to Firestore
      </button>

      <p className="mt-6">Products Loaded: {products.length}</p>
      <StoreBranding />
      <OrderExport />
 

    </div>
  );
}
